import type { Ref } from "vue";
import type { Requests } from "../common/request.common";
import type { APIKeyResponseTypes } from "../common/response.common";
import { asUpdateHook, get, post, postEmpty } from "./common";

export const apiKey = {
    record(data: typeof Requests.APIKey.Record.Input) {
        return post<typeof data, APIKeyResponseTypes.Record>("/api-key/record", data);
    },
    create(data: typeof Requests.APIKey.Create.Input) {
        return post<typeof data, APIKeyResponseTypes.Create>("/api-key/create", data);
    },
    obtain(id: string) {
        return get<APIKeyResponseTypes.Obtain>(`/api-key/obtain/${id}`);
    },
    delete(id: string) {
        return postEmpty(`/api-key/delete/${id}`);
    },
    formHooks: {
        update(id: string, isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.APIKey.Update.Input) => {
                return await asUpdateHook(
                    post<typeof data>(`/api-key/update/${id}`, data),
                    isLoading,
                );
            };
        },
    },
};
